import { Add } from "./Add"
import { Chat } from "./Chat"
import { Focus } from "./Focus"
import { Layout } from "./Layout"
import { Move } from "./Move"
import { Mute } from "./Mute"
import { PlayPause } from "./PlayPause"
import { Remove } from "./Remove"
import { Share } from "./Share"
import { Source } from "./Source"
import { Update } from "./Update"
import { actions } from "./utils"

export function Preview({ option }) {
  const selectedOption = actions.find((opt) => opt.id === option)

  return (
    <div className="flex flex-none flex-col justify-start overflow-y-auto p-6 sm:h-[28rem] sm:w-2/3 sm:justify-around">
      {selectedOption.id === "layout" && <Layout />}
      {selectedOption.id === "move" && <Move />}
      {selectedOption.id === "share" && <Share />}
      {selectedOption.id === "add" && <Add />}
      {selectedOption.id === "mute" && <Mute />}
      {selectedOption.id === "playPause" && <PlayPause />}
      {selectedOption.id === "remove" && <Remove />}
      {selectedOption.id === "update" && <Update />}
      {selectedOption.id === "focus" && <Focus />}
      {selectedOption.id === "chat" && <Chat />}
      {selectedOption.id === "source" && <Source />}
    </div>
  )
}
